// removed by extract-text-webpack-plugin
module.exports = {"container":"G5d0b1f","description":"G51454b"};